module.exports = __webpack_public_path__ + "img/no-calendar-price-message.c3c84611.png";